import { HomePage } from 'pages/HomePage';
import './App.scss';
import { Route, Routes } from 'react-router';
import { CaseStudyPage } from 'pages/CaseStudyPage';
import { APP_ROUTES } from 'routes';
import { lazy, Suspense } from 'react';

// Lazy so the event page's fonts and styles only load on its route
const AiSignupPage = lazy(() => import('pages/AiSignupPage').then(m => ({ default: m.AiSignupPage })));

const App = () => {
  return (
    <div className='app'>
      <Routes>
        <Route path={APP_ROUTES.HOME.route} element={<HomePage />} />
        <Route path={APP_ROUTES.CASE_STUDIES.route} element={<CaseStudyPage />} />
        <Route
          path={APP_ROUTES.AI_SIGNUP.route}
          element={
            <Suspense fallback={null}>
              <AiSignupPage />
            </Suspense>
          }
        />
      </Routes>
    </div>
  );
};

export default App;
